export const SOCIAL_PLATFORMS = [
  { key: 'facebook', label: 'Facebook', icon: 'mdi:facebook', color: '#1877F2' },
  { key: 'twitter', label: 'Twitter/X', icon: 'mdi:twitter', color: '#1DA1F2' },
  { key: 'instagram', label: 'Instagram', icon: 'mdi:instagram', color: '#E4405F' },
  { key: 'linkedin', label: 'LinkedIn', icon: 'mdi:linkedin', color: '#0A66C2' },
  { key: 'youtube', label: 'YouTube', icon: 'mdi:youtube', color: '#FF0000' },
  { key: 'tiktok', label: 'TikTok', icon: 'ic:baseline-tiktok', color: '#000000' },
  { key: 'pinterest', label: 'Pinterest', icon: 'mdi:pinterest', color: '#E60023' },
  { key: 'threads', label: 'Threads', icon: 'simple-icons:threads', color: '#000000' },
  { key: 'snapchat', label: 'Snapchat', icon: 'mdi:snapchat', color: '#FFFC00' },
  { key: 'whatsapp', label: 'WhatsApp', icon: 'mdi:whatsapp', color: '#25D366' },
  { key: 'telegram', label: 'Telegram', icon: 'mdi:telegram', color: '#26A5E4' },
  { key: 'discord', label: 'Discord', icon: 'ic:baseline-discord', color: '#5865F2' },
  { key: 'reddit', label: 'Reddit', icon: 'mdi:reddit', color: '#FF4500' },
] as const;

export type SocialPlatformKey = (typeof SOCIAL_PLATFORMS)[number]['key'];
